import Settings from "../../../settings";
import {
  SUBMIT_INSTALLATION_DATA,
  SUBMIT_PERSON_DATA,
  SUBMIT_PAYMENT_DATA,
  SUBMIT_CONTRACT_DATA,
  SUBMIT_DUAL_CONTRACT_DATA,
  SUBMIT_CONFIRMATION_DATA,
  NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST,
  NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE,
  RECEIVE_CONTRACTATION_CONFIG,
  RECEIVE_DUAL_CONTRACTATION_CONFIG,
  SET_LEAD_ID,
  SET_GAS_LEAD_ID,
  SET_LEAD_STEP_CURRENT,
  SET_LEAD_INDEX_COMPLETED,
  SET_LEAD_ERRORS,
  SET_LEAD_SUBMIT_REQUEST,
  RESET_CONTRACTATION
} from "../../../constants";
import { createReducer } from "../../../utils/misc";


const initialState = {
  
  submitting: false,
  leadId: null,
  gasLeadId: null,
  leadsConsent: false,
  leadErrors: {
    badScore: false,
    dniInvalid: false,
    genericError: false
  },

  latestStep: 0,
  completedSteps: {},
  currentStep: {
    index: 0,
    name : "installation"
  },

  config: {
    name: '',
    surName1: '',
    surName2: '',
    mobile: '',
    vat: '',
    email: '',
    isFetching: true
  },
  gasConfig: {
    name: '',
    surName1: '',
    surName2: '',
    mobile: '',
    vat: '',
    email: '',
    isFetching: true
  },

  steps: {
    installation: {
      cups: '',
      cupsSIPSData: {
        cupsAvailable: true,
        sipsDataAvailable: false,
        power: null,
        power2: null,
        power3: null,
        power4: null,
        power5: null,
        power6: null,
        accessTariff: null,
        selfcons: false,
        selfconsCode: '00'
      },
      address: {
        dp: '',
        ine: '',
        nv: '',
        pnp: '',
        poblacio: '',
        state: '',
        tv: '',
        aclarador: '',
        bq: '',
        es: '',
        pt: '',
        pu: '',
        ref_catastral: '',
      },
      residenceType: (Settings.contractation?.defaultCnaeCheck ?? true) ? "habitual" : "",
      cnae: (Settings.contractation?.defaultCnaeCheck ?? true) ? { 
        id: 986, 
        name: "9820", 
        descripcio: "9820: Actividades de los hogares como productores de servicios para uso propio" 
      } : null,
      invoice: [],
      comerOrigin: null,
      activeContract: null,
      acceptMorosityVerification: false,
    },
    person: {
      vat: null,
      company: false,
      name: null,
      surName1: null,
      surName2: null,
      cif: null,
      changeOwner: null,
      vatRepresentante: null,
      nameRepresentante: null,
      surName1Representante: null,
      surName2Representante: null,
      sameInvoiceAddress: true,
      ownerAddress: {
        dp: '',
        ine: '',
        nv: '',
        pnp: '',
        poblacio: '',
        state: null,
        tv: null,
        aclarador: '',
        bq: '',
        es: '',
        pt: '',
        pu: '',
        ref_catastral: '',
      },
      commsLanguage: null,
      email: null,
      mobile: null,
      nifFaceup: null
    },
    contract: {
      power: null,
      power2: null,
      power3: null,
      power4: null,
      power5: null,
      power6: null,
      accessTariff: null,
      accessTariffName: '',
      selfcons: null,
      selfconsCode: '00',
      selfconsAttachments: [],
      selectedProduct: null,
      selectedProductName: '',
      promotionalCode: '',
    },
    gasContract: {
      comerOrigin: null,
      includeGas: false,
      cups: '',
      cupsSIPSData: {
        cupsAvailable: true
      },
      changeOwner: '',
      accessTariff: null,
      selectedProduct: null,
      selectedProductName: '',
      invoice: []
    },
    payment: {
      iban: '',
      isOwner: false,
    },
    confirmation: {
      acceptOVConditions: false,
      acceptGdpr: false,
      acceptPublicity: false,
      isConfirming: false,
      confirmStatus: 'pending', // 'pending' | 'OK'
      confirmResponse: null,
    }
  },
  
  availableProducts: [],
  selectedProduct: null,
  selectedProductName: null,
};

let reducerMap = {
  [SET_LEAD_ID]: (state, payload) => 
    Object.assign({}, state, {
      leadId: payload.leadId,
  }),
  [SET_GAS_LEAD_ID]: (state, payload) => ({
      ...state,
      gasLeadId: payload,
  }),
  [SET_LEAD_STEP_CURRENT]: (state, payload) =>
    Object.assign({}, state, {
      currentStep: {
        index: payload.index,
        name: payload.name
      }
  }),
  [SET_LEAD_INDEX_COMPLETED]: (state, payload) =>
    Object.assign({}, state, {
      completedSteps: {
        ...state.completedSteps,
        [payload.stepIndex]: true
      },
      latestStep: payload.stepIndex + 1,
      submitting: false
  }),
  [SET_LEAD_SUBMIT_REQUEST]: (state) =>
   Object.assign({}, state, {
    submitting: true,
  }),
  [SET_LEAD_ERRORS]: (state, payload) => {
    return {
      ...state,
      leadErrors: {
        ...state.leadErrors,
        ...payload
      }
    }
  },
  [SUBMIT_INSTALLATION_DATA]: (state, payload) => {
    const newState = {
      ...state,
      leadsConsent: payload.leadsConsent,
      steps: {
        ...state.steps,
        installation: {...payload}
      }
    };
    delete newState.steps.installation.leadsConsent;
    return newState;
  },
  [SUBMIT_PERSON_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        person: payload
      }
    }
  },
  [SUBMIT_CONTRACT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        contract: payload
      }
    }
  },
  [SUBMIT_DUAL_CONTRACT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        gasContract: payload
      }
    }
  },
  [SUBMIT_PAYMENT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        payment: payload
      }
    }
  },
  [SUBMIT_CONFIRMATION_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          ...payload
        }
      }
    }
  },
  [NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST]: (state) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          isConfirming: true
        }
      }
    }
  },
  [NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE]: (state, payload) =>{
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          ...payload,
          isConfirming: false
        }
      }
    }
  },
  // [FETCH_CONTRACTATION_CONFIG_REQUEST]: (state, payload) => {
  //   return {
  //     ...state,
  //     isFetching: true
  //   }
  // },
  [RECEIVE_CONTRACTATION_CONFIG]: (state, payload) => {
    return {
      ...state,
      config: {
        ...(payload ? payload : {}),
        isFetching: false
      }
    }
  },
  [RECEIVE_DUAL_CONTRACTATION_CONFIG]: (state, payload) => {
    return {
      ...state,
      gasConfig: {
        ...(payload ? payload : {}),
        isFetching: false
      }
    }
  },
  [RESET_CONTRACTATION]: (state) => {
    return initialState;
  }
};

export default createReducer(initialState, reducerMap);